<template>
  <v-container class="containerBanner">
    <v-card class="infoBanner d-flex rounded-0">
      <v-col class="info-v-align">
        <Subscribers :totalSubscribers="totalSubscribers" />
      </v-col>
      <v-col class="info-v-align">
        <NumberOfProjects :numberOfProjects="projectCount" />
      </v-col>
    </v-card>
    <div
      class="mb-8"
      style="background-color: white; border-top: none !important"
    >
      <div class="white ml-3 mt-3">
        <v-row>
          <v-col
            ><v-select
              v-model="selecteState"
              label="State"
              :items="StateNames"
              item-text="stateText"
              item-value="stateKey"
              class="selectBox"
          /></v-col>
          <v-col>
            <v-select
              v-model="selectedTechnology"
              label="Technology"
              :items="technology"
              item-text="title"
              item-value="shortName"
              class="selectBox"
          /></v-col>
          <v-col v-if="isAdmin">
            <v-select
              v-model="selectedUser"
              label="User"
              :items="userName"
              item-text="name"
              item-value="_id"
              class="selectBox"
          /></v-col>
          <v-col v-if="isAdmin">
            <v-select
              v-model="isActive"
              label="Active/Deleted"
              :items="active"
              item-text="name"
              item-value="shortName"
              class="selectBox"
          /></v-col>

          <div class="button">
            <v-btn   class="filler-btn" text @click="getFilteredProjects"  plain>
              Apply
            </v-btn>
          </div>
          <div class="button" >
            <v-btn   class="filler-btn" text @click="resetFilter" plain>
              Clear
            </v-btn>
          </div>
          <div v-if="isAdmin"  class="button">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  plain
                  v-bind="attrs"
                  v-on="on"
                  large
                  icon
                  @click="getFilteredProjects"
                >
                  <v-icon  style="margin-left:-20px">mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </div>
        
        </v-row>

        <!-- <div height="72px" class="px-2 d-flex align-center white" style="width: 50%">
          <div class="d-flex align-center flex" style="width: 50%">
            <v-col class="select-filter-col" style="max-width: 100px">
              <v-select
                v-model="selecteState"
                label="State"
                :items="StateNames"
                item-text="stateText"
                item-value="stateKey"
                class="selectBox"
               style="max-width:100px"
              />
            </v-col>
            <v-col class="select-filter-col" style="max-width: 100px">
              <v-select
                v-model="selectedTechnology"
                label="Technology"
                :items="technology"
                item-text="title"
                item-value="shortName"
                class="selectBox"
                 style="max-width:100px"
              />
            </v-col>
            <template v-if="isAdmin" style="padding-left: 50pt">
              <v-col class="select-filter-col" style="max-width: 100px">
                <v-select
                  v-model="selectedUser"
                  label="User"
                  :items="userName"
                  item-text="name"
                  item-value="_id"
                  class="selectBox"
                   style="max-width:100px"
                />
              </v-col>
              <v-col class="select-filter-col active-col"  style="max-width: 100px">
                <v-select
                  v-model="isActive"
                  label="Active/Deleted"
                  :items="active"
                  item-text="name"
                  item-value="shortName"
                  class="selectBox"
                   style="max-width:100px"
                />
              </v-col>
            </template>

            <div >
              <v-btn class="filler-btn" text @click="getFilteredProjects">
                Apply
              </v-btn>
            </div>
            <div >
              <v-btn  class="filler-btn" text @click="resetFilter"> Clear </v-btn>
            </div>
          </div>
          <div class="mx-2" v-if="isAdmin">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  large
                  icon
                  @click="getFilteredProjects"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </div>
        </div> -->
      </div>

      <div class="pa-4">
        <ProjectList
          v-if="!isAdmin"
          :projects="Projects"
          @onItemClick="onItemClick"
          :loading="loading"
        />
      </div>
      <DataTable
        v-if="isAdmin"
        :projects="Projects"
        :source="source"
        :Loading="loading"
        :headers="projectHeaders"
        :isShowProjectDetails="true"
        :bordered="false"
      />
    </div>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable";
import dataService from "@/libs/dataService.js";
import { toTitleCase } from "@/utility/stringFormat.js";
import ProjectList from "@/components/ProjectList.vue";
import NumberOfProjects from "@/components/projectCount.vue";
import Subscribers from "@/components/subscripers.vue";
import moment from "moment";

export default {
  name: "Projects",
  components: {
    ProjectList,
    NumberOfProjects,
    Subscribers,
    DataTable,
  },
  data() {
    return {
      source: "",
      isActive: "",
      loading: true,
      isDesc: false,
      filter: [],
      users: [],
      Projects: [],
      states: [],
      technologyTypes: [],
      Latest: ["Latest", "Oldest"],
      selecteState: null,
      selectedTechnology: null,
      selectedUser: null,
      totalSubscribers: 0,
      projectCount: 0,
      projectHeaders: [
        {
          text: "Title",
          width: "20%",
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: "Updated",
          value: "_updated",
          width: "12%",
          sort: (a, b) => {
            return moment.utc(a).diff(moment.utc(b));
          },
        },
        {
          text: "Status",
          value: "status",
          tooltip: this.statusTooltip,
          width: "10%",
          align: "center",
        },
        {
          text: "Published",
          value: "isPublished",
          width: "12%",
          align: "center",
        },
        {
          text: "Active",
          value: "_deleted",
          width: "10%",
          align: "center",
        },
        
        {
          text: "Action",
          value: "custom_action",
          width: "35%",
          align: "center",
          sortable: false,
        },
        
        {
          text: "Report",
          value: "Report",
          width: "5%",
          align: "center",
          sortable: false,
        },
      ],
    };
  },

  mounted() {
    this.getProjectList();
    this.fillTechnologyTypes();
    this.getUserCount();
    if (this.isAdmin) {
      this.getusers();
      this.getAdminStateNames();
    } else {
      this.getStateNames();
    }
  },
  computed: {
    active() {
      let active = [
        { name: "Active", shortName: false },
        { name: "Deleted", shortName: true },
      ];
      return active;
    },
    isAdmin() {
      const adminStatus = window.localStorage.getItem("admin");
      if (adminStatus) {
        return adminStatus === "true";
      }
      return false;
    },
    StateNames() {
      return this.states.slice().sort(function (a, b) {
        return a.stateKey > b.stateKey ? 1 : -1;
      });
    },
    technology() {
      return this.technologyTypes.slice().sort(function (a, b) {
        return a.shortName > b.shortName ? 1 : -1;
      });
    },
    userName() {
      return this.users.slice().sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
    },
  },
  methods: {
    onItemClick(project) {
      if (project && project.reportId) {
        // this.$router.push(`/report/${project._id}`);
        this.$router.push(`/report/${project.reportId}`);
      }
    },
    getusers() {
      dataService.list("account-names").then((res) => {
        this.users = res;
      });
    },
    getUserCount() {
      dataService.getSubscriberCount().then((res) => {
        this.totalSubscribers = res.data.count;
      });
    },
    resetFilter() {
      this.selecteState = 0;
      this.selectedTechnology = 0;
      this.selectedUser = 0;
      this.isActive = "";
    },

    fillTechnologyTypes() {
      dataService.list("technologyTypes/active").then((res) => {
        this.technologyTypes = res;
      });
    },

    getProjectList() {
      if (this.isAdmin) {
        this.source = "projects";
      } else if (!this.isAdmin) {
        this.source = "projects/published";
      }
      this.loading = true;
      dataService
        .list(this.source)
        .then((res) => {
          const sortedList = res.sort((a, b) => {
            return moment.utc(b._updated).diff(moment.utc(a._updated));
          });
          this.Projects = sortedList;
          this.projectCount = this.Projects.length;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStateNames() {
      dataService.list("projects-published/states").then((res) => {
        this.states = res.map((state) => {
          return {
            stateText: toTitleCase(state),
            stateKey: state,
          };
        });
      });
    },
    getAdminStateNames() {
      dataService.list("projects/states").then((res) => {
        this.states = res.map((state) => {
          return {
            stateText: toTitleCase(state),
            stateKey: state,
          };
        });
      });
    },
    getFilteredProjects() {
      if (this.isAdmin) {
        this.source = "projects";
      } else if (!this.isAdmin) {
        this.source = "projects/published";
      }

      this.filter = [];
      let whereClause = "";

      if (this.selecteState) {
        this.filter.push(`"feederData.stateName":"${this.selecteState}"`);
      }

      if (this.selectedTechnology) {
        this.filter.push(`"technologyType":"${this.selectedTechnology}"`);
      }

      if (this.selectedUser) {
        this.filter.push(`"owner":"${this.selectedUser}"`);
      }
      if (this.isActive !== "") {
        // console.log("this.isActive", this.isActive);
        this.filter.push(`"_deleted":${this.isActive}`);
      }

      this.filter.forEach((item) => {
        whereClause = `${whereClause}${item},`;
      });

      if (whereClause !== "") {
        whereClause = whereClause.slice(0, -1);
        whereClause = `?where={${whereClause}}`;
      }

      this.loading = true;
      dataService
        .list(`${this.source}${whereClause}`)
        .then((res) => {
          this.Projects = res;
          this.projectCount = this.Projects.length;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    sortby() {
      this.isDesc = !this.isDesc;

      if (this.isDesc) {
        this.Projects.sort((a, b) => {
          return new Date(a._created) - new Date(b._created);
        });
        return this.items;
      } else {
        this.Projects.sort((b, a) => {
          return new Date(a._created) - new Date(b._created);
        });
        return this.Projects;
      }
    },
  },
};
</script>
<style scoped>
.v-select__selections input {
  display: none;
}
.select-filter-col {
  flex: 1;
}
.active-col {
  /* max-width: 100px; */
}
.default-border {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.infoBanner {
  /* height: 250px; */
  height: 172.6853px;
  width: 848.5641px;
  margin: auto;
  background-image: linear-gradient(to right, #6bbc56, #2fa9d8);
}
.info-v-align {
  margin-top: 30pt;
}
.containerBanner {
  /* max-width: 1200px;
  border-width: 2px;
  border-style: solid;
  border-image: linear-gradient(to right, #eb9135, #6bbc56 55%, #2fa9d8 75%) 1; */
  margin-top:40px;
  max-width: 848.5641px;
  border-width: 0.75pt;
  border-style: solid;
  border-image: linear-gradient(to right, #6bbc56, #6bbc56 55%, #2fa9d8 75%) 1;
}
/* .v-btn__content{
 font-size: 14px;
  color: #8A8C8E;
   text-transform:capitalize;
} */
.filler-btn {
  font-size: 14px;
  color: #39393a;
  text-transform: capitalize;
}
.filter {
  border-style: solid;
  border-color: #bfbebd;
}
.filter-content {
  /* padding-left: 10pt;
  padding-right: 10pt; */
}
.selectBox.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.selectBox.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
.button {
  margin-block: 25px;
  display: inline-block;
  line-height: 30px;
}
</style>
